import { createLogger } from 'shared/services/logger';

const logger = createLogger('UScope:extensions:Snapshot:RenderEngine');

/**
 * This module coordinates the rendering of many drawing surfaces on a single "thread".
 */

export function RenderEngine () {
  const self = this;
  // Stores all surfaces that will be rendered in the render cycle.
  const renderQueue = [];
  // The master timer, received from the browser.
  let frameId = null;

  /**
     * Walks all surfaces and calls draw() on them.
     * NOTE 1: Silently eats all exceptions.
     * NOTE 2: Will stop the master timer if the renderQueue is empty.
     */
  function renderSurfaces () {
    if (renderQueue.length === 0) {
      self.stop();
      return;
    }

    for (let i = 0; i < renderQueue.length; i++) {
      try {
        renderQueue[i].draw();
      } catch (e) {
        logger.error('Error drawing surface.', e);
        // TODO: Maybe handle troublesome surfaces?
      }
    }
    // Note: use setTimeout so individual renders actually finish before attempting to render again. The implication
    // of this is that refreshes may happen less often than interval.
    frameId = requestAnimationFrame(renderSurfaces);
  }

  /**
     * Simply adds a drawing surface to render queue.
     */
  this.addSurface = (surface) => {
    renderQueue.push(surface);
  };

  /**
     * Removes a drawing surface from the render queue. Also calls destroy on the surface.
     */
  this.removeSurface = (surface) => {
    surface.destroy();
    renderQueue.splice(renderQueue.indexOf(surface), 1);
  };

  /**
     * Stops the master timer and empties the render queue.
     */
  this.stop = () => {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }
    renderQueue.splice(0);
  };

  /**
     * Starts the master timer.
     */
  this.start = () => {
    if (!frameId) {
      renderSurfaces();
    }
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/RenderEngine.js